var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      id: "areaManagement"
    }
  }, [_vm.dataList.length > 0 ? _c("a-table", {
    staticClass: "components-table-demo-nested",
    attrs: {
      rowKey: function rowKey(record, index) {
        return index;
      },
      defaultExpandAllRows: true,
      columns: _vm.columns,
      loading: _vm.isTableLoading,
      "data-source": _vm.dataList,
      pagination: false
    },
    scopedSlots: _vm._u([{
      key: "areaStatus",
      fn: function fn(text) {
        return [text == 1 ? _c("a-tag", {
          attrs: {
            color: "blue"
          }
        }, [_vm._v(_vm._s(_vm.$t("publicuse.enable")))]) : _vm._e(), text == 0 ? _c("a-tag", {
          attrs: {
            color: "red"
          }
        }, [_vm._v(_vm._s(_vm.$t("publicuse.disabled")))]) : _vm._e()];
      }
    }, {
      key: "operation",
      fn: function fn(text, record) {
        return [record.areaStatus == 1 ? _c("a-popconfirm", {
          attrs: {
            title: _vm.$t("public.sureStop"),
            "ok-text": _vm.$t("public.confirm"),
            "cancel-text": _vm.$t("public.cancel")
          },
          on: {
            confirm: function confirm($event) {
              return _vm.updateStatus(record, "area");
            }
          }
        }, [record.areaStatus == 1 ? _c("a", [_vm._v(_vm._s(_vm.$t("public.disable")))]) : _vm._e()]) : _vm._e(), record.areaStatus == 0 ? _c("a-popconfirm", {
          attrs: {
            title: _vm.$t("public.sureEnable"),
            "ok-text": _vm.$t("public.confirm"),
            "cancel-text": _vm.$t("public.cancel")
          },
          on: {
            confirm: function confirm($event) {
              return _vm.updateStatus(record, "area");
            }
          }
        }, [record.areaStatus == 0 ? _c("a", [_vm._v(_vm._s(_vm.$t("public.enable")))]) : _vm._e()]) : _vm._e()];
      }
    }, {
      key: "expandedRowRender",
      fn: function fn(record) {
        return _c("a-table", {
          attrs: {
            rowKey: function rowKey(record, index) {
              return index;
            },
            columns: _vm.innerColumns,
            "data-source": record.addressList,
            pagination: false
          },
          scopedSlots: _vm._u([{
            key: "areaStatus",
            fn: function fn(text) {
              return [text == 1 ? _c("a-tag", {
                attrs: {
                  color: "blue"
                }
              }, [_vm._v(_vm._s(_vm.$t("publicuse.enable")))]) : _vm._e(), text == 0 ? _c("a-tag", {
                attrs: {
                  color: "red"
                }
              }, [_vm._v(_vm._s(_vm.$t("publicuse.disabled")))]) : _vm._e()];
            }
          }, {
            key: "operation",
            fn: function fn(text, record) {
              return [record.areaStatus == 1 ? _c("a-popconfirm", {
                attrs: {
                  title: _vm.$t("public.sureStop"),
                  "ok-text": _vm.$t("public.confirm"),
                  "cancel-text": _vm.$t("public.cancel")
                },
                on: {
                  confirm: function confirm($event) {
                    return _vm.updateStatus(record, "areaDetail");
                  }
                }
              }, [record.areaStatus == 1 && record.defaultStatus == 0 ? _c("a", [_vm._v(_vm._s(_vm.$t("public.disable")))]) : _vm._e()]) : _vm._e(), record.areaStatus == 0 ? _c("a-popconfirm", {
                attrs: {
                  title: _vm.$t("public.sureEnable"),
                  "ok-text": _vm.$t("public.confirm"),
                  "cancel-text": _vm.$t("public.cancel")
                },
                on: {
                  confirm: function confirm($event) {
                    return _vm.updateStatus(record, "areaDetail");
                  }
                }
              }, [record.areaStatus == 0 ? _c("a", [_vm._v(_vm._s(_vm.$t("public.enable")))]) : _vm._e()]) : _vm._e(), record.defaultStatus == 0 ? _c("a-divider", {
                attrs: {
                  type: "vertical"
                }
              }) : _vm._e(), record.defaultStatus == 0 && record.areaStatus == 1 ? _c("a-popconfirm", {
                attrs: {
                  title: _vm.$t("areaManagement.confirmPrompt"),
                  "ok-text": _vm.$t("public.confirm"),
                  "cancel-text": _vm.$t("public.cancel")
                },
                on: {
                  confirm: function confirm($event) {
                    return _vm.setDefault(record.id, record);
                  }
                }
              }, [_c("a", {
                attrs: {
                  href: "#"
                }
              }, [_vm._v(_vm._s(_vm.$t("areaManagement.setDefault")))])]) : _vm._e(), record.defaultStatus == 1 ? _c("span", [_vm._v(_vm._s(_vm.$t("areaManagement.default")))]) : _vm._e()];
            }
          }], null, false, 3594725771)
        });
      }
    }], null, false, 797824352)
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };